export default __webpack_public_path__ + "static/header-9d81e9ea25606610e69ad86883dae5a0.png";